import React, { useEffect } from 'react';
import {
  Typography,
  Box,
  Paper,
  Grid,
  CircularProgress,
  Alert,
  Button,
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAccountDetails } from '../store/actions/accountActions';
import MicroSiteList from '../components/MicroSite/MicroSiteList';
import AccountLayout from '../layouts/AccountLayout';

function AccountDashboard() {
  const { accountId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentAccount, isLoading, error } = useSelector((state) => state.account);

  useEffect(() => {
    if (accountId) {
      dispatch(fetchAccountDetails(accountId))
        .catch((error) => {
          console.error('Failed to load account:', error);
          navigate('/dashboard', { 
            state: { message: 'Failed to load account details' } 
          });
        });
    }
  }, [accountId, dispatch, navigate]);

  if (isLoading) {
    return (
      <AccountLayout>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      </AccountLayout>
    );
  }

  if (error) {
    return (
      <AccountLayout>
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
        <Button onClick={() => navigate('/dashboard')}>
          Return to Dashboard
        </Button>
      </AccountLayout>
    );
  }

  if (!currentAccount) {
    return null;
  }

  return (
    <AccountLayout>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          {currentAccount.name}
        </Typography>
        <Typography color="text.secondary">
          Account Overview
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6} lg={4}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Account Details
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" color="text.secondary">
                Type: {currentAccount.type}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Status: {currentAccount.status}
              </Typography>
              {currentAccount.nextDueDate && (
                <Typography variant="body2" color="text.secondary">
                  Next Payment: {new Date(currentAccount.nextDueDate).toLocaleDateString()}
                </Typography>
              )}
            </Box>
          </Paper>
        </Grid>
      </Grid>

      <Box sx={{ mt: 4 }}>
        <MicroSiteList accountId={accountId} />
      </Box>
    </AccountLayout>
  );
}

export default AccountDashboard; 